function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React, { useState, useEffect } from 'react';
import { Col, Card, Row, Tabs, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ClaimGroupUserAccessForm from './ClaimGroupUserAccessForm';
import UserProjectAccess from './UserProjectAccess';
import UnitsAndProjectsUserAccessesList from './UnitsAndProjectsUserAccessesList';
import FoldersAndFilesUserAccessesList from './FoldersAndFilesUserAccessesList';
const EditUserAccessModal = _ref => {
  let {
    show,
    title,
    onHide,
    onSubmit,
    userAccess,
    company,
    claimGroup,
    setClaimGroup,
    onClaimScheduleClientContactParticipationChange
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [clientContact, setClientContact] = useState(_objectSpread({}, userAccess));
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setClientContact(_objectSpread({}, userAccess));
  }, [userAccess]);
  const clientContactModalBody = () => /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(ClaimGroupUserAccessForm, {
    clientContact: clientContact,
    setClientContact: setClientContact
  })), /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(UserProjectAccess, {
    onClaimScheduleClientContactParticipationChange: onClaimScheduleClientContactParticipationChange,
    userAccess: clientContact,
    setClientContact: setClientContact,
    company: company,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    loading: loading,
    setLoading: setLoading
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "projects_and_units"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "projects_and_units",
    title: t('projects_and_business_units')
  }, /*#__PURE__*/React.createElement(UnitsAndProjectsUserAccessesList, {
    userAccess: clientContact,
    onClaimScheduleClientContactParticipationChange: onClaimScheduleClientContactParticipationChange,
    setLoading: setLoading,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    loading: loading
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "folders_and_files",
    title: t('individual_file_folder_access')
  }, /*#__PURE__*/React.createElement(FoldersAndFilesUserAccessesList, {
    userAccess: clientContact,
    onClaimScheduleClientContactParticipationChange: onClaimScheduleClientContactParticipationChange,
    setLoading: setLoading,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    loading: loading
  })))))))));
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: t(title),
    show: show,
    renderBody: () => clientContactModalBody(),
    onHide: onHide,
    onSubmit: () => onSubmit(clientContact)
  });
};
export default EditUserAccessModal;